'use client';

import { useEffect, useRef, useState } from 'react';

type Props = {
  children: React.ReactNode;
};

export default function LazyImageSection({ children }: Props) {
  const ref = useRef<HTMLSpanElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <span ref={ref} style={{ display: 'block', height: 0, overflow: 'hidden' }} />
      {isVisible ? children : null}
    </>
  );
}
